"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateJson = void 0;
var model_actions_types_1 = require("./model.actions.types");
function updateJson(payload) {
    return {
        type: model_actions_types_1.UPDATE_JSON,
        payload: payload
    };
}
exports.updateJson = updateJson;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW9kZWwuYWN0aW9ucy5jcmVhdG9ycy5qcyIsInNvdXJjZVJvb3QiOiIuLyIsInNvdXJjZXMiOlsicGRmL3N0b3JlL21vZGVsLmFjdGlvbnMuY3JlYXRvcnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsNkRBQWlEO0FBRWpELFNBQWdCLFVBQVUsQ0FBQyxPQUFPO0lBQzlCLE9BQU87UUFDSCxJQUFJLEVBQUUsaUNBQVc7UUFDakIsT0FBTyxTQUFBO0tBQ1YsQ0FBQTtBQUNMLENBQUM7QUFMRCxnQ0FLQyJ9